import * as ID from '@/constants/identifier';
import * as A from '@/constants/assets';
import * as C from '@/constants/colors';
import { BOY_NAME, BOY_NAME_SHORT, GIRL_NAME, GIRL_NAME_SHORT, THE_BRIDE } from '.';

export const IMAGE_HELPER_LINK =
  'https://docs.google.com/document/d/1VBUWjh7s2nQkL3dXuXn41IuHLO6XL3YooZ0MQQlj6ok/edit?usp=sharing';
export const ASSETS_HELPER_LINK = '';

export const COLOR_DEFAULT_VALUES = [
  {
    colorCSS: 'bgPrimary',
    colorName: 'Background Utama',
    colorValue: C.BG_PRIMARY,
    colorSectionId: ID.ID_COUPLE_SECTION,
  },
  {
    colorCSS: 'bgSecondary',
    colorName: 'Background Sekunder',
    colorValue: C.BG_SECONDARY,
    colorSectionId: ID.ID_WISH_SECTION,
  },
  {
    colorCSS: 'bgAlternative',
    colorName: 'Background Alternatif',
    colorValue: C.BG_ALTERNATIVE,
    colorSectionId: ID.ID_RSVP_SECTION,
  },
  {
    colorCSS: 'bgStepRSVP',
    colorName: 'Warna Step RSVP',
    colorValue: C.BG_STEP_RSVP,
    colorSectionId: ID.ID_RSVP_SECTION,
  },
  {
    colorCSS: 'mainColorText',
    colorName: 'Teks Utama',
    colorValue: C.TEXT_PRIMARY,
    colorSectionId: ID.ID_DETAIL_SECTION,
  },
  {
    colorCSS: 'secondaryColorText',
    colorName: 'Teks Sekunder',
    colorValue: C.TEXT_SECONDARY,
    colorSectionId: 'invitato-detail-content',
  },
  {
    colorCSS: 'alternativeColorText',
    colorName: 'Teks Alternatif',
    colorValue: C.TEXT_ALTERNATIVE,
    colorSectionId: 'invitato-detail-content',
  },
];

export const IMAGES_DEFAULT_VALUES = [
  { imageConstant: 'BG_COVER', imageName: 'Background Cover', imageValue: A.BG_COVER },
  {
    imageConstant: 'BG_COVER_SLIDESHOW_1',
    imageName: 'Background Cover Slideshow 1',
    imageValue: A.BG_COVER_SLIDESHOW_1,
  },
  {
    imageConstant: 'BG_COVER_SLIDESHOW_2',
    imageName: 'Background Cover Slideshow 2',
    imageValue: A.BG_COVER_SLIDESHOW_2,
  },
  {
    imageConstant: 'BG_COVER_SLIDESHOW_3',
    imageName: 'Background Cover Slideshow 3',
    imageValue: A.BG_COVER_SLIDESHOW_3,
  },
  {
    imageConstant: 'BG_COVER_SLIDESHOW_4',
    imageName: 'Background Cover Slideshow 4',
    imageValue: A.BG_COVER_SLIDESHOW_4,
  },
  {
    imageConstant: 'BG_COVER_SLIDESHOW_5',
    imageName: 'Background Cover Slideshow 5',
    imageValue: A.BG_COVER_SLIDESHOW_5,
  },
  {
    imageConstant: 'IMG_BRIDE_GROOM',
    imageName: 'Bride Groom Image',
    imageValue: A.IMG_BRIDE_GROOM,
  },
  { imageConstant: 'BG_RSVP', imageName: 'Background RSVP', imageValue: A.BG_RSVP },
  { imageConstant: 'BG_GIFTCARD', imageName: 'Background Giftcard', imageValue: A.BG_GIFTCARD },
  {
    imageConstant: 'BG_IG_FILTER',
    imageName: 'Background Instagram Filter',
    imageValue: A.BG_IG_FILTER,
  },
  {
    imageConstant: 'BG_LIVESTREAM',
    imageName: 'Background Livestream',
    imageValue: A.BG_LIVESTREAM,
  },
  { imageConstant: 'IMG_LOVE_STORY', imageName: 'Love Story Image', imageValue: A.IMG_LOVE_STORY },
  { imageConstant: 'IMG_FOOTER_1', imageName: 'Footer Image 1', imageValue: A.IMG_FOOTER_1 },
  { imageConstant: 'IMG_FOOTER_2', imageName: 'Footer Image 2', imageValue: A.IMG_FOOTER_2 },
  { imageConstant: 'IMG_FOOTER_3', imageName: 'Footer Image 3', imageValue: A.IMG_FOOTER_3 },
  {
    imageConstant: 'BG_DESKTOP_VIEW',
    imageName: 'Background Desktop View',
    imageValue: A.BG_DESKTOP_VIEW,
  },
];

export const COUPLE_DEFAULT_VALUES = {
  coupleName: THE_BRIDE,
  brideName: GIRL_NAME_SHORT,
  groomName: BOY_NAME_SHORT,
  brideFullName: GIRL_NAME,
  groomFullName: BOY_NAME,
};

export const FONTS_DEFAULT_VALUES = [
  {
    fontCSS: 'heading',
    fontName: 'Heading',
    fontFamilyValue: 'Butler',
    fontSizeValue: '32',
    fontWeightValue: '300',
    isFontItalic: false,
    fontCategory: 'heading',
    fontSectionId: ID.ID_COUPLE_SECTION,
  },
  {
    fontCSS: 'body',
    fontName: 'Body',
    fontFamilyValue: 'Newsreader',
    fontSizeValue: '18',
    fontWeightValue: 'regular',
    isFontItalic: true,
    fontCategory: 'body',
    fontSectionId: ID.ID_DETAIL_SECTION,
  },
  {
    fontCSS: 'body_lv2',
    fontName: 'Body Alternatif',
    fontFamilyValue: 'Poppins',
    fontSizeValue: '16',
    fontWeightValue: '700',
    isFontItalic: false,
    fontCategory: 'body',
    fontSectionId: ID.ID_DETAIL_SECTION,
  },
];
